<template>
    <header :class="[
        'fixed top-0 left-0 right-0 z-50 transition-all duration-300 ease-in-out border-b border-transparent',
        isScrolled
            ? 'bg-white/80 backdrop-blur-md py-3 border-border/40 shadow-sm'
            : 'bg-transparent py-6'
    ]">
        <div class="container mx-auto px-4 md:px-8 flex items-center justify-between">

            <!-- Logo -->
            <RouterLink to="/" class="flex items-center gap-3 group">
                <div
                    class="relative overflow-hidden rounded-full border border-border/20 shadow-sm transition-transform duration-300 group-hover:scale-105">
                    <img :src="logoImg" alt="ArtPulse by Shruti Logo" class="w-10 h-10 md:w-12 md:h-12 object-cover" />
                </div>
                <div class="flex flex-col">
                    <span class="font-serif text-lg md:text-xl font-medium tracking-tight leading-none text-primary">
                        ArtPulse
                    </span>
                    <span class="text-[10px] md:text-xs uppercase tracking-widest text-muted-foreground font-sans">
                        By Shruti
                    </span>
                </div>
            </RouterLink>

            <!-- Desktop Navigation -->
            <nav class="hidden md:flex items-center gap-8">
                <RouterLink v-for="item in navItems" :key="item.href" :to="item.href"
                    class="text-sm font-medium tracking-wide transition-colors hover:text-primary relative py-1" :class="route.path === item.href
                        ? 'text-primary after:absolute after:bottom-0 after:left-0 after:w-full after:h-[1px] after:bg-primary'
                        : 'text-muted-foreground'
                        ">
                    {{ item.label }}
                </RouterLink>
            </nav>

            <!-- Actions -->
            <div class="hidden md:flex items-center gap-4">
                <a href="https://www.youtube.com/@artpulse_by_shruti" target="_blank" rel="noopener noreferrer"
                    class="text-muted-foreground hover:text-[#FF0000] transition-colors">
                    <!-- <YoutubeIcon class="w-5 h-5" /> -->
                    <i class="fa-brands fa-youtube"></i>
                </a>

                <button @click="$router.push('/contact')"
                    class="rounded-none border border-primary text-primary hover:bg-primary hover:text-black transition-all duration-300 text-xs tracking-widest uppercase px-6 py-2 border-black">
                    Inquire
                </button>
            </div>

            <!-- Mobile Menu Toggle -->
            <button class="md:hidden text-2xl" @click="isOpen = true">
                <!-- <i class='bx bx-menu'></i> -->
                 <i class="fa-solid fa-bars"></i>
            </button>

            <!-- Mobile Drawer Menu -->
            <transition name="slide-right">
                <div v-if="isOpen" class="fixed inset-0 z-40 md:hidden">
                    <!-- Overlay -->
                    <div class="absolute inset-0 bg-black/50" @click="isOpen = false"></div>

                    <!-- Drawer -->
                    <div class="absolute right-0 top-0 h-full w-80 bg-white shadow-xl flex flex-col">
                        <!-- Close Button -->
                        <button class="p-4 flex justify-end text-2xl hover:text-primary transition-colors"
                            @click="isOpen = false">
                            <i class="fa-solid fa-x"></i>
                        </button>

                        <!-- Navigation Links -->
                        <nav class="flex flex-col px-6 space-y-2 flex-1 bg-white">
                            <RouterLink v-for="item in navItems" :key="item.href" :to="item.href"
                                class="px-4 py-3 text-lg font-serif font-medium rounded-md transition-colors" :class="route.path === item.href
                                    ? 'bg-primary/10 text-primary'
                                    : 'text-gray-700 hover:bg-gray-100'" @click="isOpen = false">
                                {{ item.label }}
                            </RouterLink>
                        </nav>

                        <!-- Mobile Actions -->
                        <div class="border-t px-6 py-6 space-y-4">
                            <button @click="() => { $router.push('/contact'); isOpen = false }"
                                class="w-full border border-primary text-primary hover:bg-primary hover:text-black transition-all text-sm tracking-widest uppercase py-2">
                                Inquire
                            </button>

                            <a href="https://www.youtube.com/@artpulse_by_shruti" target="_blank"
                                class="flex items-center justify-center gap-2 text-sm font-medium text-gray-700 hover:text-red-600">
                                <i class="fa-brands fa-youtube"></i>
                                YouTube
                            </a>
                        </div>
                    </div>
                </div>
            </transition>

        </div>
    </header>
</template>

<script>
// import { Menu as MenuIcon, X as XIcon, Youtube as YoutubeIcon } from 'lucide-vue-next'
import { useRoute } from 'vue-router'

export default {
    name: 'TopHeader',

    //   components: {
    //     MenuIcon,
    //     XIcon,
    //     YoutubeIcon
    //   },

    data() {
        return {
            isScrolled: false,
            isOpen: false,
            navItems: [
                { label: 'Home', href: '/' },
                { label: 'Gallery', href: '/gallery' },
                { label: 'Commission', href: '/commission' },
                { label: 'Kids’ Classes', href: '/kids-classes' },
                { label: 'Exhibitions', href: '/exhibition' },
                // { label: 'Testimonials', href: '/testimonial' },
                { label: 'About', href: '/about' },
                { label: 'Contact', href: '/contact' },
            ],
            logoImg: "https://assets-allwebsites.s3.ap-south-1.amazonaws.com/artpulse/logoartpulse.jpeg"
        }
    },

    computed: {
        route() {
            return useRoute()
        }
    },

    methods: {
        handleScroll() {
            this.isScrolled = window.scrollY > 20
        }
    },

    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },

    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
<style>
/* Right slide animation */
.slide-right-enter-active,
.slide-right-leave-active {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-right-enter-from {
    transform: translateX(100%);
    opacity: 0;
}

.slide-right-leave-to {
    transform: translateX(100%);
    opacity: 0;
}
</style>